import { API_PREFIX } from '@src/shared/constants/apiRoutes';

import client from '../utils/client';

type ISaveParams = Record<string, any> & { formId: number };

// todo прописать тип для unknown
export const save = async (params: ISaveParams): Promise<unknown> => {
  const { data } = await client.post<unknown>(`${API_PREFIX}/forms/save/`, params);

  return data;
};
